import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  width: 100%;
  margin-top: 1rem;
`;

export const WrapperInCall = styled.div`
  display: flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.4rem 0.8rem 0.4rem 0.1rem;
  background: linear-gradient(
    135deg,
    ${(props) =>
      props.variant === 2
        ? "#00c896 0%, #00a884 100%"
        : props.variant === 3
        ? "#9e9e9e 0%, #757575 100%"
        : "#ff5252 0%, #ff5252 100%"}
  );
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  user-select: none;
  position: relative;
  overflow: hidden;
  height: 18px;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.2),
      transparent
    );
    transition: left 0.5s;
  }

  .call-icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 16px;
    height: 16px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 50%;
    animation: ${(props) =>
      props.variant === 3 ? "none" : "callPulse 2s infinite"};
    position: relative;

    .call-icon {
      font-size: 0.7rem;
      color: #ffffff;
      z-index: 1;
    }

    &::after {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      width: 100%;
      height: 100%;
      border: 1px solid rgba(255, 255, 255, 0.6);
      border-radius: 50%;
      transform: translate(-50%, -50%);
      animation: ${(props) =>
        props.variant === 3 ? "none" : "callRipple 2s infinite"};
    }
  }

  .call-text {
    color: #ffffff;
    font-weight: 600;
    font-size: 0.8rem;
    letter-spacing: 0.2px;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    line-height: 1;
  }

  @keyframes callPulse {
    0%,
    100% {
      transform: scale(1);
      background: rgba(255, 255, 255, 0.2);
    }
    50% {
      transform: scale(1.1);
      background: rgba(255, 255, 255, 0.3);
    }
  }

  @keyframes callRipple {
    0% {
      transform: translate(-50%, -50%) scale(1);
      opacity: 1;
    }
    100% {
      transform: translate(-50%, -50%) scale(1.5);
      opacity: 0;
    }
  }

  @media (max-width: 768px) {
    padding: 0.1rem 0.3rem;
    gap: 0.2rem;

    .call-icon-wrapper {
      width: 14px;
      height: 14px;

      .call-icon {
        font-size: 0.5rem;
      }
    }

    .call-text {
      font-size: 0.5rem;
    }
  }
`;
